module.exports = __webpack_public_path__ + "static/media/prefill-gif-purplish-blue.44527496.gif";